import { openDB, deleteDB } from "idb";
import { stores } from "./stores";

// const stores=['COMMON','DB','STORIES','CALENDAR', 'VAL']

const dbPromise =
    typeof window !== "undefined"
        ? openDB("DBW", 1, {
              upgrade(db) {
                  process.env.NODE_ENV === "development" &&
                      console.group("%c Open database ", "background: #1b6ef3; color: #FFF");
                  stores.forEach((store) => {
                      const _store = db.createObjectStore(store);
                      process.env.NODE_ENV === "development" &&
                          console.log(
                              `%c "${store}": ${!!_store ? "ok " : "error "}`,
                              `background: ${!!_store ? "#FFF" : "#F00"}; color: #000000de;`
                          );
                  });
                  process.env.NODE_ENV === "development" && console.groupEnd();
              },
          })
        : false;

export const getItem = async (key) => (await dbPromise).get("COMMON", key);

export const setItem = async (key, val) => (await dbPromise).put("COMMON", val, key);

export const delItem = async (key) => (await dbPromise).delete("COMMON", key);

export const clear = async () => (await dbPromise).clear("COMMON");

export const keys = async () => (await dbPromise).getAllKeys("COMMON");

export const open = async () => await dbPromise; //.getAll();

export const deleteDatabase = async () => {
    const delPromise =
        typeof window !== "undefined"
            ? deleteDB("DBW", {
                  blocked() {},
              })
            : false;

    // return delPromise;
};
